"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * LiBat Gestion
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAccountUpdateToJSON = exports.IAccountUpdateFromJSONTyped = exports.IAccountUpdateFromJSON = void 0;
const runtime_1 = require("../runtime");
function IAccountUpdateFromJSON(json) {
    return IAccountUpdateFromJSONTyped(json, false);
}
exports.IAccountUpdateFromJSON = IAccountUpdateFromJSON;
function IAccountUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
    };
}
exports.IAccountUpdateFromJSONTyped = IAccountUpdateFromJSONTyped;
function IAccountUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'description': value.description,
    };
}
exports.IAccountUpdateToJSON = IAccountUpdateToJSON;
